"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=event-arg.type.js.map